import { call, fork, put, select, take } from "redux-saga/effects";

// Actions
import * as actionsCreator from "./reducer";

// Helper
import { RootState } from "store";
import { filteredDataPrices, optionsPrices } from "lib/helpers";
// import { librariesCompounds } from "../LibrariesCompounds/saga";

// Store
export const settings = (store: RootState) => store.settings;

function* _select<T>(fn: (state: RootState) => T) {
  const res: T = yield select(fn);
  return res;
}

// Type
type TMap = {
  [index: string]: string | number | boolean
}
type TOptions = {
  label?: string;
  value?: string;
};

// Start Sagas
export function* chemicalProbesSagaStart(api: any, action: any) {
  yield fork(getChemicalProbesWatcher, api, action);
}

/**
 *  Get all chemical probes watcher sagas
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getChemicalProbesWatcher(api: any, action: any): Generator<any, void, any> {
  while (true) {
    try {
      yield take(actionsCreator.getChemicalProbes.type);

      const res = yield call(api.request, "getChemicalProbes");

      if (!res.ok) {
        yield put(actionsCreator.getChemicalProbesError());
      } else {
        let countPrice = 0;
        const state = yield* _select(settings);
        const currentPrice = state.currentPrice;
        const priceApp = JSON.parse(localStorage.getItem("priceApp") || "{}");

        const formData = res.data?.length ? res.data.map(({ compound, ...rest }: any) => {
          const optionsPr = compound.prices?.length
            ? filteredDataPrices(compound.prices)?.map((item: TMap) =>
              optionsPrices(item)
            ) : [];

          optionsPr.forEach((item: TMap) => {
            if (item.value === undefined) {
              countPrice += 1;
            }

            countPrice = 0;
          });

          return {
            ...compound,
            ...rest,
            quantity: 1,
            selected: false,
            currentTypePrice: "EBC",
            px: rest.px ? rest.px : '',
            action: rest.action ? rest.action : '',
            isPOA: optionsPr.length === countPrice,
            currentPrice: Object.values(priceApp).length ? priceApp : currentPrice,
          }
        }) : [];

        const getFilteredPX: any = [ ...new Set(formData.map((item: any) => item.px).filter(Boolean)) ];
        const getFilteredAction: any = [ ...new Set(formData.map((item: any) => item.action).filter(Boolean)) ];

        const optionsAction: TOptions[] = getFilteredAction?.length ? getFilteredAction?.map((item: string) => ({
          label: item,
          value: item
        })) : [];
        const optionsPX: TOptions[] = getFilteredPX?.length ? getFilteredPX?.map((item: string) => ({
          label: item,
          value: item
        })) : [];

        optionsAction.unshift({
          label: 'All',
          value: ''
        });

        yield put(actionsCreator.getChemicalProbesSuccess({
          px: optionsPX,
          data: formData,
          action: optionsAction,
        }));
      }
    } catch (e) {
      console.log("CATCH ERROR: getChemicalProbesWatcher: ", e);
    }
  }
}
